import { createRoot } from 'react-dom/client';
import '@styles/index.scss';
import App from './App.tsx';
import './i18n';
import DynamicThemeProvider from '@styles/theme/dynamic-theme-provider.tsx';
import {
  capturePendingChat,
  capturePendingNotificationRead
} from '@services/onesignal/pending-deeplink.ts';

// Capture cold notification deep-links (`?openChat=`, `?notificationId=`) before
// the router mounts and RoleBasedRedirect strips the query.
capturePendingChat();
capturePendingNotificationRead();

createRoot(document.getElementById('root')!).render(
  <DynamicThemeProvider>
    <App />
  </DynamicThemeProvider>
);
